import Canvas from "../index.js"
import * as Objdict from "objdict"

const loader = {"images": {}}
const performer = {}

export {loader, performer}

function createShader(gl, type, source) {
    var shader = gl.createShader(type)
    gl.shaderSource(shader, source)
    gl.compileShader(shader)
    const hasCompiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS)
    if(hasCompiled == false) {
        console.log(gl.getShaderInfoLog(shader))
        gl.deleteShader(shader)
        return
    }

    return shader
}
function createProgram(gl, vertexShader, fragmentShader) {
    var program = gl.createProgram()
    gl.attachShader(program, vertexShader)
    gl.attachShader(program, fragmentShader)
    gl.linkProgram(program)
    var hasCompiled = gl.getProgramParameter(program, gl.LINK_STATUS)
    if(hasCompiled == false) {
        console.log(gl.getProgramInfoLog(program))
        gl.deleteProgram(program)
        return
    }
    return program
}

// input
// {
//     "shaders": {
//         "vertex": "GLSL SOURCE CODE",
//         "fragment": "GLSL SOURCE CODE",
//     },
//     "attributes": ["ARRAY", "OF", "NAMES"],
//     "uniforms": ["ARRAY", "OF", "NAMES"],
// }
// output
// {
//     "program": WEBGL PROGRAM,
//     "shaders": {
//         "vertex": WEBGL SHADER,
//         "fragment": WEBGL SHADER,
//     },
//     "attributes": {
//         "ARRAY": WEBGL LOCATION,
//         "OF": WEBGL LOCATION,
//         "NAMES": WEBGL LOCATION
//     },
//     "uniforms": {
//         ...
//     }
// }
function createBundle(bundle) {
    bundle.shaders.vertex = createShader(gl, gl.VERTEX_SHADER, bundle.shaders.vertex)
    bundle.shaders.fragment = createShader(gl, gl.FRAGMENT_SHADER, bundle.shaders.fragment)
    bundle.program = createProgram(gl, bundle.shaders.vertex, bundle.shaders.fragment)

    bundle.attributes = bundle.attributes.map((attribute) => {
        return {"key": attribute, "location": gl.getAttribLocation(bundle.program, attribute)}
    })
    bundle.uniforms = bundle.uniforms.map((uniform) => {
        return {"key": uniform, "location": gl.getUniformLocation(bundle.program, uniform)}
    })

    bundle.attributes = Objdict.map(Objdict.convert(bundle.attributes), (attribute) => attribute.location)
    bundle.uniforms = Objdict.map(Objdict.convert(bundle.uniforms), (uniform) => uniform.location)

    return bundle
}

////////////////////
// INSTANTIATING //
//////////////////

let gl = undefined
const _ = {}
performer.start = function(settings) {
    // canvas
    Canvas.dom = document.createElement("canvas")
    Canvas.domparent = Canvas.domparent || document.body
    Canvas.domparent.appendChild(Canvas.dom)
    Canvas.dom.width = Canvas.size.width
    Canvas.dom.height = Canvas.size.height
    // dom.style.width = "100%"
    // dom.style.height = "100%"
    // dom.style.position = "absolute"
    Canvas.dom.style.width = settings.frame.width + "em"
    Canvas.dom.style.height = settings.frame.height + "em"
    Canvas.dom.addEventListener("contextmenu", (event) => {
        event.preventDefault()
    })

    if(Canvas.isPixelated == true) {
        if(CSS.supports("image-rendering", "crisp-edges")) {
            Canvas.dom.style.imageRendering = "crisp-edges"
        }
        if(CSS.supports("image-rendering", "pixelated")) {
            Canvas.dom.style.imageRendering = "pixelated"
        }
    }

    // gl
    gl = Canvas.dom.getContext("webgl2", {
        "premultipliedAlpha": false
    })
    if(gl === undefined) throw new Error("webgl2 is not supported :(")

    // program setup
    // pointers
    _.bundles = {
        "sprite": createBundle({
            "shaders": {
                "vertex": require("./shaders/sprite.vertex.glsl").default,
                "fragment": require("./shaders/sprite.fragment.glsl").default,
            },
            "attributes": ["position", "textureCoord"],
            "uniforms": ["resolution", "tintIntensity", "tintColor", "outlineColor", "outlineThickness", "grayscaleIntensity", "imageSize", "opacity", "isFlipped", "isPaletteSwapped", "paletteImage", "textureImage"],
        }),
        "rectangle": createBundle({
            "shaders": {
                "vertex": require("./shaders/rectangle.vertex.glsl").default,
                "fragment": require("./shaders/rectangle.fragment.glsl").default,
            },
            "attributes": ["position"],
            "uniforms": ["resolution", "color"],
        }),
    }

    // vertex array ??
    _.vao = gl.createVertexArray()
    gl.bindVertexArray(_.vao)

    // position
    _.positionBuffer = gl.createBuffer()

    // view port
    gl.viewport(0, 0, gl.canvas.width, gl.canvas.height)

    gl.enable(gl.BLEND)
}


//////////////
// LOADING //
////////////

loader.count = 0
loader.start = function() {
    if(Canvas.preload != undefined) {
        loader.preload = Canvas.preload
        return loader.loadAll(loader.preload, () => loader.count++).then((images) => {
            images.forEach((image) => {
                if(image == undefined) return
                performer.processImageIntoTexture(image)
            })
            loader.isPreloaded = true
        })
    }
}

loader.loadAll = function(sources, afterEach) {
    if(sources == undefined) {
        return Promise.resolve([])
    }
    if(sources instanceof Array) {
        return Promise.all(sources.map((source) => {
            if(source == undefined) return Promise.resolve()
            return loader.load(source).then((response) => {
                if(afterEach instanceof Function) {
                    afterEach(response)
                }
                return response
            })
        }))
    }
}
loader.load = function(source) {
    if(loader.images[source] != undefined) {
        return Promise.resolve(loader.images[source])
    }
    const image = new Image()
    loader.images[source] = image
    loader.images[source].crossOrigin = "anonymous"
    loader.images[source].src = source
    return new Promise((resolve, reject) => {
        image.onload = function() {
            image.isLoaded = true
            resolve(image)
        }
        image.onerror = function() {
            image.isLoaded = false
            console.error(image)
            resolve(image)
        }
    })
}

performer.processImageIntoTexture = function(image) {
    const texCoordBuffer = gl.createBuffer()
    gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer)
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0.0,  0.0, 1.0,  0.0, 0.0,  1.0, 0.0,  1.0, 1.0,  0.0, 1.0,  1.0]), gl.STATIC_DRAW)
    gl.enableVertexAttribArray(_.bundles["sprite"].attributes["textureCoord"])
    var size = 2          // 2 components per iteration
    var type = gl.FLOAT   // the data is 32bit floats
    var normalize = false // don't normalize the data
    var stride = 0        // 0 = move forward size * sizeof(type) each iteration to get the next position
    var offset = 0        // start at the beginning of the buffer
    gl.vertexAttribPointer(_.bundles["sprite"].attributes["textureCoord"], size, type, normalize, stride, offset)

    // Create a texture.
    var texture = gl.createTexture()

    // make unit 0 the active texture uint
    // (ie, the unit all other texture commands will affect
    gl.activeTexture(gl.TEXTURE0)
    image.index = 0

    // Bind it to texture unit 0' 2D bind point
    gl.bindTexture(gl.TEXTURE_2D, texture)

    // Set the parameters so we don't need mips and so we're not filtering
    // and we don't repeat
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST)

    // Upload the image into the texture.
    var mipLevel = 0               // the largest mip
    var internalFormat = gl.RGBA   // format we want in the texture
    var srcFormat = gl.RGBA        // format of data we are supplying
    var srcType = gl.UNSIGNED_BYTE  // type of data we are supplying
    gl.texImage2D(gl.TEXTURE_2D, mipLevel, internalFormat, srcFormat, srcType, image)
    image.isProcessedIntoTexture = true
    image.texture = texture
}

/////////////////
// PERFORMING //
///////////////

performer.clear = function() {
    gl.clearColor(0, 0, 0, 0)
    gl.clear(gl.COLOR_BUFFER_BIT)
}

performer.render = function(renderable) {
    // inputs into this:
    // {
    //     image,
    //     color,
    //     opacity,
    //     tint,
    //     grayscale,
    //     bounds: {
    //         x1
    //         x2
    //         y1
    //         y2,
    //         width, // ??
    //         height, // ??
    //     }
    // }
    // everything else should be done in canvas/index.js

    if(renderable.blendmode == "cool") {
        gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA)
    } else {
        gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA)
        // gl.blendFunc(gl.SRC_ALPHA, gl.ONE)
        // gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA) // tavern
    }

    if(renderable.color != undefined) {
        gl.useProgram(_.bundles["rectangle"].program)
        gl.bindVertexArray(_.vao)

        gl.uniform2f(_.bundles["rectangle"].uniforms["resolution"], gl.canvas.width, gl.canvas.height)

        if(renderable.color == undefined) renderable.color = "#FF69B4"
        if(renderable.opacity == undefined) renderable.opacity = 1
        // renderable.color = parseColor(renderable.color)
        gl.uniform4f(_.bundles["rectangle"].uniforms["color"], ...renderable.color, renderable.opacity)

        // if(renderable.radius != undefined) {
        //     renderable.width = renderable.radius * 2
        //     renderable.height = renderable.radius * 2
        //     renderable.position = renderable.position || {}
        //     renderable.position.x = renderable.position.x || 0
        //     renderable.position.y = renderable.position.y || 0
        //     // renderable.position.x -= renderable.radius
        //     // renderable.position.y -= renderable.radius
        // }
        // if(renderable.width == undefined
        // || renderable.height == undefined) {
        //     return
        // }

        const points = getRectanglePoints(renderable)
        gl.bindBuffer(gl.ARRAY_BUFFER, _.positionBuffer)
        gl.enableVertexAttribArray(_.bundles["rectangle"].attributes["position"])
        gl.vertexAttribPointer(_.bundles["rectangle"].attributes["position"], 2, gl.FLOAT, false, 0, 0)
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(points), gl.STATIC_DRAW)
        gl.drawArrays(gl.TRIANGLES, 0, 6)
    }

    if(renderable.image != undefined) {

        if(renderable.image == undefined) {
            console.log(renderable)
            throw new Error("Could not find renderable.image")
        }

        if(renderable.image.default != undefined) {
            console.log(renderable)
            throw new Error("Could not handle a non-defaulted image import")
        }

        if(loader.images[renderable.image] == undefined) {
            loader.load(renderable.image).then((image) => {
                performer.processImageIntoTexture(image)
            })
        }
        if(loader.images[renderable.image].isLoaded != true
        || loader.images[renderable.image].isProcessedIntoTexture != true) {
            return
        }

        gl.useProgram(_.bundles["sprite"].program)
        gl.bindVertexArray(_.vao)

        gl.uniform1i(_.bundles["sprite"].uniforms["textureImage"], 0)
        gl.activeTexture(gl.TEXTURE0)
        gl.bindTexture(gl.TEXTURE_2D, loader.images[renderable.image].texture)
        gl.uniform2f(_.bundles["sprite"].uniforms["resolution"], gl.canvas.width, gl.canvas.height)
        gl.uniform2f(_.bundles["sprite"].uniforms["imageSize"], loader.images[renderable.image].width, loader.images[renderable.image].height)
        // gl.uniform1i(_.imageUniformLocation, loader.images[renderable.image].index)

        if(renderable.opacity == undefined) renderable.opacity = 1
        gl.uniform1f(_.bundles["sprite"].uniforms["opacity"], renderable.opacity)

        if(renderable.tint != undefined) {
            // renderable.tint.color = parseColor(renderable.tint.color)
            if(renderable.tint.opacity == undefined) renderable.tint.opacity = 1
            if(renderable.tint.intensity == undefined) renderable.tint.intensity = 1
            gl.uniform4f(_.bundles["sprite"].uniforms["tintColor"], ...renderable.tint.color, renderable.tint.opacity)
            gl.uniform1f(_.bundles["sprite"].uniforms["tintIntensity"], renderable.tint.intensity)
        } else {
            gl.uniform4f(_.bundles["sprite"].uniforms["tintColor"], 0, 0, 0, 0)
            gl.uniform1f(_.bundles["sprite"].uniforms["tintIntensity"], 0)
        }

        if(renderable.grayscale != undefined) {
            renderable.grayscale.value = renderable.grayscale.value || 0
            gl.uniform1f(_.bundles["sprite"].uniforms["grayscaleIntensity"], renderable.grayscale.value)
        } else {
            gl.uniform1f(_.bundles["sprite"].uniforms["grayscaleIntensity"], 0)
        }

        if(renderable.outline != undefined) {
            // renderable.outline.color = parseColor(renderable.outline.color)
            if(renderable.outline.opacity == undefined) renderable.outline.opacity = 1
            if(renderable.outline.thickness == undefined) renderable.outline.thickness = 1
            gl.uniform4f(_.bundles["sprite"].uniforms["outlineColor"], ...renderable.outline.color, renderable.outline.opacity)
            gl.uniform1f(_.bundles["sprite"].uniforms["outlineThickness"], renderable.outline.thickness)
        } else {
            gl.uniform4f(_.bundles["sprite"].uniforms["outlineColor"], 0, 0, 0, 0)
            gl.uniform1f(_.bundles["sprite"].uniforms["outlineThickness"], 0)
        }

        if(renderable.isFlipped == true) {
            gl.uniform1f(_.bundles["sprite"].uniforms["isFlipped"], 1)
        } else {
            gl.uniform1f(_.bundles["sprite"].uniforms["isFlipped"], 0)
        }

        gl.uniform1f(_.bundles["sprite"].uniforms["isPaletteSwapped"], 0)
        if(renderable.palette != undefined) {
            if(renderable.palette.default != undefined) {
                console.log(renderable.palette)
                throw new Error("Could not handle a non-defaulted palette image import")
            }
            if(loader.images[renderable.palette] == undefined) {
                loader.load(renderable.palette).then((image) => {
                    performer.processImageIntoTexture(image)
                })
            }
            if(loader.images[renderable.palette].isLoaded == true
            && loader.images[renderable.palette].isProcessedIntoTexture == true) {
                gl.uniform1f(_.bundles["sprite"].uniforms["isPaletteSwapped"], 1)

                gl.uniform1i(_.bundles["sprite"].uniforms["paletteImage"], 1)
                gl.activeTexture(gl.TEXTURE1)
                gl.bindTexture(gl.TEXTURE_2D, loader.images[renderable.palette].texture)
            }
        }

        const points = getRectanglePoints(renderable)
        gl.bindBuffer(gl.ARRAY_BUFFER, _.positionBuffer)
        gl.enableVertexAttribArray(_.bundles["sprite"].attributes["position"])
        gl.vertexAttribPointer(_.bundles["sprite"].attributes["position"], 2, gl.FLOAT, false, 0, 0)
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(points), gl.STATIC_DRAW)
        gl.drawArrays(gl.TRIANGLES, 0, 6)
    }
}

function getRectanglePoints(entity) {
    const x1 = Math.round(entity.bounds.x1)
    const y1 = Math.round(entity.bounds.y1)
    const x2 = Math.round(entity.bounds.x2)
    const y2 = Math.round(entity.bounds.y2)
    return [
        x1, y1,
        x2, y1,
        x1, y2,
        x1, y2,
        x2, y1,
        x2, y2
    ]
}
